<template>
<div class="container-fluid">
                    <!-- 404 Error Text -->
                    <div class="text-center">
                        <div class="error mx-auto"><h1>404</h1></div>
                        <p class="lead text-gray-800 mb-5">Página não encontrada</p>
                        <p class="text-gray-500 mb-0">O conteúdo que você procura não existe</p>
                        <router-link to="/">← Voltar para o Dashboard</router-link>
                    </div>
                </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/PageNotFound.vue